import React from 'react'
import { Pagination } from 'react-bootstrap'

const PaginationC = ({ data, onPageChange }) => {

  const handleClick = (page) => {
    if (onPageChange) onPageChange(page);
  };

  return (
    <>
      <div className="table-responsive d-flex justify-content-end pe-4">
        {
          (data?.total_pages > 0) &&
          <Pagination>
            <Pagination.Prev
              onClick={() => handleClick(data?.page - 1)}
              disabled={data?.page === 1 ? true : false} style={{ opacity: data?.page === 1 ? 0.5 : 1 }}
            >
            </Pagination.Prev>
            {
              (data?.page > 2) && (data?.total_pages !== 3) &&
              <Pagination.Ellipsis onClick={() => handleClick(data?.page - 2)} />
            }
            {
              (data?.page == data?.total_pages) && (data?.total_pages > 2) &&
              <Pagination.Item
                active={data?.page === (data?.page - 2)}
                onClick={() => handleClick(data?.page - 2)}
              >
                {data?.page - 2}
              </Pagination.Item>
            }

            {
              (data?.page != 1) &&
              <Pagination.Item
                active={data?.page === (data?.page - 1)}
                onClick={() => handleClick(data?.page - 1)}
              >
                {data?.page - 1}
              </Pagination.Item>
            }
            <Pagination.Item
              active={data?.page === (data?.page)}
              onClick={() => handleClick(data?.page)}
            >
              {data?.page}
            </Pagination.Item>
            {
              (data?.page !== data?.total_pages) &&
              <Pagination.Item
                active={data?.page === (data?.page + 1)}
                onClick={() => handleClick(data?.page + 1)}
              >
                {data?.page + 1}
              </Pagination.Item>
            }
            {
              (data?.page == 1) && (data?.total_pages > (data?.page + 1)) &&
              <Pagination.Item
                active={data?.page === (data?.page + 2)}
                onClick={() => handleClick(data?.page + 2)}
              >
                {data?.page + 2}
              </Pagination.Item>
            }

            {
              (data?.total_pages > (data?.page + 1)) && (data?.total_pages !== 3) &&
              <Pagination.Ellipsis onClick={() => handleClick(data?.page + 2)} />
            }
            <Pagination.Next
              onClick={() => handleClick(data?.page + 1)}
              disabled={data?.page === data?.total_pages ? true : false} style={{ opacity: data?.page === data?.total_pages ? 0.5 : 1 }}
            >
            </Pagination.Next>
          </Pagination>
        }
      </div>
    </>
  )
}

export default PaginationC;